<template>
  <div class="axj_web_certification">
    <axj_certification_top/>
    <axj_certification_body
      :userId="userId"
    />
  </div>
</template>

<script>
import Axj_certification_body from "./component/axj_certfication_body/index";
import Axj_certification_top from "./component/axj_certification_top/index"
export default {
  name: "axj_web_certification",
  components:{
    Axj_certification_body,
    Axj_certification_top
  },
  data(){
    return{
      userId:undefined
    }
  },
  created() {
    // if(!this.$store.getters.getLoginInfo.userId){
    //   this.$router.push({
    //     path:"/"
    //   })
    //   return
    // }
    // this.userId=this.$store.getters.getLoginInfo.userId
  }
}
</script>

<style scoped>
.axj_web_certification{
  background-image:url("https://img.aixuejie.cn/extra/showclub/5_1603682078/5_爱学界_1603682110_43324814c73b8ea0551e8c6505b4b61c.png");
  background-size: cover;
  background-repeat: no-repeat no-repeat;
  background-color:  #0E1623;
  display: flex;
  flex-flow: column;
  height: 100%;
  min-height: 1400px;
}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/axj_certification/index.vue